import { formatMoney } from '../../../lib/currency'
import { Field, FieldProps, useControlId } from './Field'

export function CurrencyField({
  label,
  error,
  hint,
  labelStyle = 'plain',
  className,
  style,
  id,
  value,
  onChange,
  ...rest
}: FieldProps & {
  value: string
  onChange: (value: string) => void
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'id' | 'className' | 'style' | 'type'>) {
  const controlId = useControlId(id)

  return (
    <Field label={label} error={error} hint={hint} labelStyle={labelStyle} className={className} style={style} controlId={controlId}>
      <div className="input-group">
        <div className="input-group-addon">$</div>
        <input
          id={controlId}
          type="text"
          className="form-control"
          value={value}
          onChange={(event) => onChange(formatMoney(event.target.value))}
          {...rest}
        />
      </div>
    </Field>
  )
}
